import { render, staticRenderFns } from "./customBoxBrand.vue?vue&type=template&id=065dd48c&scoped=true&"
import script from "./customBoxBrand.vue?vue&type=script&lang=js&"
export * from "./customBoxBrand.vue?vue&type=script&lang=js&"
import style0 from "./customBoxBrand.vue?vue&type=style&index=0&id=065dd48c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065dd48c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('065dd48c')) {
      api.createRecord('065dd48c', component.options)
    } else {
      api.reload('065dd48c', component.options)
    }
    module.hot.accept("./customBoxBrand.vue?vue&type=template&id=065dd48c&scoped=true&", function () {
      api.rerender('065dd48c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customChildren/customBoxBrand.vue"
export default component.exports